import React from 'react';
import SiteNav from '../components/SiteNav';
import SiteFooter from '../components/SiteFooter';
import { BLOG_POSTS } from '../data/blogPosts';

const BlogIndex: React.FC = () => {
  return (
    <div className="landing-page">
      <SiteNav currentPage="home" />

      {/* Hero */}
      <section className="page-hero">
        <div className="container">
          <h1 className="page-hero-title">Blog</h1>
          <p className="page-hero-subtitle" style={{ fontStyle: 'normal' }}>
            Tips, guides, and insights to help your child succeed in the 11+
          </p>
        </div>
      </section>

      {/* Intro */}
      <section className="blog-intro-section">
        <div className="container">
          <div className="blog-intro">
            <p>
              Preparing for the 11+ can feel overwhelming &mdash; there's so much to cover and it's hard to know where to start.
              Our blog is here to help. We share practical advice on study routines, subject-specific tips, and honest guidance
              on what actually works. Whether your child is just starting Year 4 or sitting the exam next term, you'll find
              articles written by parents and educators who understand what you're going through. From breaking down the
              differences between GL and CEM exams to managing exam-day nerves, we cover the topics that matter most to
              11+ families.
            </p>
          </div>
        </div>
      </section>

      {/* Posts Grid */}
      <section className="blog-section">
        <div className="container">
          <div className="blog-grid">
            {BLOG_POSTS.map((post) => (
              <a key={post.slug} href={`/blog/${post.slug}`} className="blog-card">
                <p className="blog-card-date">
                  {new Date(post.date).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}
                  {' '}&middot;{' '}{post.author}
                </p>
                <h3>{post.title}</h3>
                <p>{post.excerpt}</p>
                <span className="blog-card-link">Read more &rarr;</span>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <div className="container">
          <h2 className="section-title" style={{ color: 'white' }}>Ready to give them a head start?</h2>
          <p className="section-subtitle" style={{ color: 'rgba(255,255,255,0.8)' }}>
            Join early access &mdash; free to start, no credit card needed.
          </p>
          <a href="/#waitlist" className="btn-primary-light">
            Get Early Access
          </a>
        </div>
      </section>

      <SiteFooter />
    </div>
  );
};

export default BlogIndex;
